import api from 'data/api';

export const loadCampaigns = api('GET /api/mobile/lookups/campaigns');
